import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translation/en.json';
import ar from './translation/ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

const win = window as unknown as { lang?: string; [k: string]: unknown };
const initialLang = win.lang ?? 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// Ensure document direction matches the CMS-provided language (window['lang'])
document.documentElement.dir = initialLang === 'ar' ? 'rtl' : 'ltr';

export default i18n;